import { render, staticRenderFns } from "./MemberWriteDefaultLayout.vue?vue&type=template&id=8bb07924&scoped=true&"
import script from "./MemberWriteDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./MemberWriteDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb07924",
  null
  
)

export default component.exports